"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const updateDAPAndDACTechOneFacility_service_1 = require("../services/updateDAPAndDACTechOneFacility.service");
require("rxjs");
require("underscore");
require("../../billing/Models");
const i0 = require("@angular/core");
const i1 = require("../services/updateDAPAndDACTechOneFacility.service");
const i2 = require("@angular/common");
function UpdateDAPAndDACTechOneFacilityComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelementStart(2, "h4", 15);
    i0.ɵɵtext(3, "Updating");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 15);
    i0.ɵɵtext(5, "We are updating DAC and DAP. Please wait until the process is completed.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 16);
    i0.ɵɵelementStart(7, "span", 17);
    i0.ɵɵtext(8, "Loading...");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function UpdateDAPAndDACTechOneFacilityComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵelementStart(2, "div", 20);
    i0.ɵɵelementStart(3, "h4", 21);
    i0.ɵɵtext(4, "Updated");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵelementStart(6, "div", 23);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "ul", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 25);
    i0.ɵɵelementStart(10, "div", 26);
    i0.ɵɵelementStart(11, "button", 27);
    i0.ɵɵlistener("click", function UpdateDAPAndDACTechOneFacilityComponent_div_16_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.closeModal(); });
    i0.ɵɵtext(12, "OK");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.result, "");
} }
function UpdateDAPAndDACTechOneFacilityComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵelementStart(2, "div", 20);
    i0.ɵɵelementStart(3, "h4", 21);
    i0.ɵɵtext(4, "Error");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵelementStart(6, "div", 23);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "ul", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 25);
    i0.ɵɵelementStart(10, "div", 26);
    i0.ɵɵelementStart(11, "button", 27);
    i0.ɵɵlistener("click", function UpdateDAPAndDACTechOneFacilityComponent_div_17_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.closeModal(); });
    i0.ɵɵtext(12, "OK");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r2.errorMessage);
} }
class UpdateDAPAndDACTechOneFacilityComponent {
    constructor(facilityService, updateDAPAndDACTechOneFacilityService) {
        this.facilityService = facilityService;
        this.updateDAPAndDACTechOneFacilityService = updateDAPAndDACTechOneFacilityService;
        this.isLoading = false;
        this.isSuccess = false;
        this.errorMessage = null;
        this.process = () => {
            const facilityId = this.selectedFacility.id;
            this.isLoading = true;
            this.isSuccess = false;
            this.updateDAPAndDACTechOneFacilityService.updateDapAndDac(facilityId)
                .then((res) => {
                this.result = res;
                this.isLoading = false;
                this.isSuccess = true;
            })
                .catch((err) => {
                this.isLoading = false;
                this.isSuccess = false;
                this.errorMessage = "Something went wrong while updating DAP/DAC";
            });
        };
    }
    ngOnInit() {
        this.facilities = this.facilityService.activeUserFacilities.filter(x => x.isBillingIntegratedFacility == true
            && x.facilityType == "AgeCare");
        this.selectedFacility = this.facilityService.selectedFacility;
    }
    closeModal() {
        this.result = null;
        this.isSuccess = false;
        this.isLoading = false;
        this.errorMessage = null;
    }
}
exports.UpdateDAPAndDACTechOneFacilityComponent = UpdateDAPAndDACTechOneFacilityComponent;
UpdateDAPAndDACTechOneFacilityComponent.ɵfac = function UpdateDAPAndDACTechOneFacilityComponent_Factory(t) { return new (t || UpdateDAPAndDACTechOneFacilityComponent)(i0.ɵɵdirectiveInject('facility.service'), i0.ɵɵdirectiveInject(i1.UpdateDAPAndDACTechOneFacilityService)); };
UpdateDAPAndDACTechOneFacilityComponent.ɵcmp = i0.ɵɵdefineComponent({ type: UpdateDAPAndDACTechOneFacilityComponent, selectors: [["updateDAPAndDACTechOneFacility"]], decls: 18, vars: 4, consts: [["nav-publisher", "customerCare", 1, "clinical-integration"], [1, "row"], [1, "page-header"], [1, "row", "space-below-8"], [1, "col-xs-1"], ["for", "facility", 1, "control-label", "v-align-middle"], [1, "col-xs-3"], [1, "control-label", "v-align-middle"], [1, "row", "space-below"], [1, "col-xs-6", "col-xs-offset-1"], ["type", "button", 1, "btn", "btn-primary", "btn-lg", "save-button", 2, "margin-left", "8px", 3, "click"], ["style", "position:fixed;top:0;left:0;width:100%;height:100%;\n            background:rgba(0,0,0,0.5);display:flex;\n            align-items:center;justify-content:center;\n            z-index:9999;", 4, "ngIf"], ["class", "modal-dialog", 4, "ngIf"], [2, "position", "fixed", "top", "0", "left", "0", "width", "100%", "height", "100%", "background", "rgba(0,0,0,0.5)", "display", "flex", "align-items", "center", "justify-content", "center", "z-index", "9999"], [2, "background", "#fff", "padding", "20px", "border-radius", "8px", "box-shadow", "0 2px 10px rgba(0,0,0,0.3)", "width", "300px", "text-align", "center"], [2, "margin-bottom", "16px"], ["role", "status", 1, "spinner-border", "text-primary"], [1, "visually-hidden"], [1, "modal-dialog"], [1, "modal-content"], ["ng-show", "title", 1, "modal-header"], ["ng-bind", "title", 1, "modal-title", "ng-binding"], ["ng-class", "modalClass", 1, "modal-body"], ["ng-bind-html", "content", 1, "ng-binding"], ["ng-if", "innerMessages", 1, "ng-scope"], [1, "modal-footer"], [1, "col-xs-3", "pull-right"], ["type", "button", 1, "btn", "btn-primary", "btn-block", "btn-lg", 3, "click"]], template: function UpdateDAPAndDACTechOneFacilityComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h1", 2);
        i0.ɵɵtext(3, "Update DAP/DAC - T1 facilities");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "label", 5);
        i0.ɵɵtext(7, "Facility");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "label", 7);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵelementStart(13, "button", 10);
        i0.ɵɵlistener("click", function UpdateDAPAndDACTechOneFacilityComponent_Template_button_click_13_listener() { return ctx.process(); });
        i0.ɵɵtext(14, "Update");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, UpdateDAPAndDACTechOneFacilityComponent_div_15_Template, 9, 0, "div", 11);
        i0.ɵɵtemplate(16, UpdateDAPAndDACTechOneFacilityComponent_div_16_Template, 13, 1, "div", 12);
        i0.ɵɵtemplate(17, UpdateDAPAndDACTechOneFacilityComponent_div_17_Template, 13, 1, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(10);
        i0.ɵɵtextInterpolate(ctx.selectedFacility.name);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.isLoading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isLoading && ctx.result);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isLoading && !ctx.isSuccess && ctx.errorMessage);
    } }, directives: [i2.NgIf], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(UpdateDAPAndDACTechOneFacilityComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'updateDAPAndDACTechOneFacility',
                templateUrl: './update-dap-dac-techone-facility.component.html'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['facility.service']
            }] }, { type: i1.UpdateDAPAndDACTechOneFacilityService }]; }, null); })();
